import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { useDropzone } from 'react-dropzone';

const StyledRoot = styled('div')({
    cursor: 'pointer',
});

const StyledInput = styled('input')({
    display: 'none',
});

const ImageDropzone = (props) => {
    const { children, onFileSelected } = props;

    const handleDrop = React.useCallback((files) => {
        onFileSelected(files[0]);
    }, [onFileSelected]);

    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop: handleDrop,
        multiple: false,
        accept: {
            'image/*': ['.jpg', '.jpeg', '.png'],
        },
    });

    return (
        <StyledRoot {...getRootProps({ id: 'direct-upload-dropzone' })}>
            <StyledInput {...getInputProps()} />
            { children }
        </StyledRoot>
    );
};

ImageDropzone.propTypes = {
    children: PropTypes.node.isRequired,
    onFileSelected: PropTypes.func.isRequired,
};

export default ImageDropzone;
